<template>
  <div
    :id="`category-${categoryId}`"
    :data-test-id="`category-${categoryIndex}`"
    :class="['cf-menu-list-target cf-menu-list__category', {
      'cf-menu-list__category--favorites': isFavoriteCategory,
      'cf-menu-list__category--specials': isSpecialCategory,
      'cf-menu-list__category--open': isCategoryOpen,
      'cf-menu-list__category--hidden': isHidden
    }]"
  >
    <button
      class="cf-menu-list__category-header"
      type="button"
      tabindex="-1"
      @click="handleMenuCategoryClick"
    >
      <!-- <div class="cf-flex cf-flex--row"> -->
      <!-- <span
          v-if="isSpecialCategory"
          class="cf-icon cf-icon--bigger fa-utensils-alt secondary"
        />

        <span
          v-if="isFavoriteCategory"
          class="cf-icon cf-icon--bigger far fa-heart secondary"
        /> -->

      <h2 class="cf-title cf-title--3 cf-no-wrap-ellipsis">
        {{ category.displayName }}
      </h2>
      <!-- </div> -->

      <cf-current-day-menu-schedule :schedule="category.schedule" />

      <p
        v-if="category.description"
        class="cf-subtitle cf-subtitle--3"
      >
        {{ category.description }}
      </p>

      <p
        v-if="isReadOnly && category.modifierSummary"
        class="cf-subtitle cf-subtitle--3"
      >
        {{ category.modifierSummary }}
      </p>
    </button>

    <div class="cf-menu-list__items">
      <cf-menu-list-item
        v-for="(item, menuItemIndex) in category.menuItems"
        :key="item.originalFavoriteItemId || item.menuItemId"
        :is-favorite="isFavoriteCategory"
        :item="item"
        :category-id="categoryId"
        :is-read-only="isReadOnly"
        :data-test-id="`menu-item-${categoryIndex}-${menuItemIndex}`"
      />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfMenuListItem from '../cf-menu-list-item/index.vue';

  import CfCurrentDayMenuSchedule from '@/view/components/globals/cf-current-day-menu-schedule/index.vue';


  export default {
    name: 'CfMenuListCategory',

    components: {
      CfMenuListItem,
      CfCurrentDayMenuSchedule
    },

    props: {
      category: {
        type: Object,
        required: true
      },

      categoryIndex: {
        type: Number,
        required: true
      },

      openCategoryIds: {
        type: Array,
        required: true
      },

      isAutoOpenCategory: {
        type: Boolean,
        default: false
      },

      isReadOnly: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('menu', ['menu']),

      categoryId() {
        return this.category.categoryId;
      },

      isCategoryOpen() {
        return this.openCategoryIds.includes(this.categoryId) || this.isAutoOpenCategory;
      },

      isSpecialCategory() {
        return this.category.categoryTemplate === 'SpecialsCategoryTemplate';
      },

      isFavoriteCategory() {
        return this.category.categoryTemplate === 'FavoritesCategoryTemplate';
      },

      isHidden() {
        return this.category.statementTemplate === 'HiddenTemplate';
      }
    },

    methods: {
      handleMenuCategoryClick() {
        this.$emit('open-menu-list-category', { categoryId: this.categoryId, doNotClose: false });
      }
    }
  };
</script>
